<template>
  <span>
    <span v-if="task.task_items.length">
      <i class="material-icons x-small-icon text-info">list</i>
    </span>
    <span v-if="task.files.length">
      <i class="material-icons x-small-icon">attach_file</i>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    task: {
      type: Object
    }
  }
}
</script>
